import { useMemo } from 'react';
import { handleDatas } from '../utils';

// 用于Middle - Long Time Financials模块处理接口数据
function useFinancialsList(props: { loading: boolean; data: any }) {
  const { loading, data } = props;

  // 将数据处理逻辑 原封不动搬到 handleDatas 方法里了，handleDatas方法在PDF下载中 也有复用
  const orgData: orgHeadcountsDataTypes = useMemo(() => {
    if (loading) return null;
    return handleDatas(data);
  }, [loading]);

  return {
    orgData,
  };
}

export default useFinancialsList;
